import { Component, Input } from "@angular/core";

@Component({
  selector: "fields-group-property",
  templateUrl: "./fields-group-property.component.html",
})
export class FieldsGroupPropertyComponent {

  @Input() public group: any;
  @Input() public properties: any[] = [];
  @Input() public depth: number = 1;

  public getValue(propertyName) {
    let pvalue = "";
    this.properties.forEach((item) => {
      if (item[0].fieldId === this.group.key) {
        item.forEach((p) => {
          if (p.propertyName === propertyName) {
            pvalue = p.propertyValue;
          }
        });
      }
    });

    return pvalue;
  }

  public toggleClass(event: any, cssclass: string) {
    const elem = event.target;
    const parent = elem.closest(".group-toggle");
    parent.classList.toggle(cssclass);
  }
}
